var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobalSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2756",
    x: 0,
    y: 0,
    width: 55,
    height: 55,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1616ad",
    floodOpacity: 0.039
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-active-icon",
    transform: "translate(-1739 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1739, 14)",
    filter: "url(#Rectangle_2756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2756-2",
    "data-name": "Rectangle 2756",
    transform: "translate(46 6) rotate(90)",
    fill: "#2467ff",
    stroke: "#2467ff",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.35,
    width: 36.3,
    height: 36.3,
    rx: 18.15,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "magnifiying-glass_1_",
    "data-name": "magnifiying-glass (1)",
    d: "M12.505,11.81,9.418,8.723a5.331,5.331,0,1,0-.7.7L11.81,12.5a.492.492,0,1,0,.7-.7ZM.984,5.324a4.34,4.34,0,1,1,4.34,4.34A4.345,4.345,0,0,1,.984,5.324Z",
    transform: "translate(1760.176 32.176)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSearch);
export default __webpack_public_path__ + "static/media/GlobalSearch.b1b6cdae.svg";
export { ForwardRef as ReactComponent };